import React, { useState, useEffect } from "react";
import "./Footer.css";
import { Link, useNavigate } from "react-router-dom";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faCrown,
  faFilePen,
  faHouse,
  faInfoCircle,
  faPhone,
  fas,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLinkedin,
  faInstagram,
  faFacebook,
  faTwitter,
  faXTwitter,
  faLinkedinIn,
  faFacebookF,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";

import Cookies from "js-cookie";
import { useContext } from "react";
import { Context } from "../../utils/context";
import NotificationModal from "../CommonPage/NotificationPage/NotificationModal";
import Login_As_Modal from "../CommonPage/Login_As_Modal/Login_As_Modal";

library.add(fas);

const Footer = () => {
  const [showIcons, setShowIcons] = useState(false);
  const [modalShow, setModalShow] = React.useState(false);
  const [icon, setIcon] = useState("+");
  const toggleIcons = () => {
    setShowIcons(!showIcons);
    setIcon(showIcons ? "+" : "x");
  };

  const {
    ReactLoader,
    setReactLoader,
    getData,
    setSignin,
    signin,
    setUsertype,
    userType,
    userdata,
  } = useContext(Context);

  const [authToken, setAuthToken] = useState(null);
  const [authType, setAuthType] = useState(null);
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const browseJob = () => {
    const featuredCategoryElement =
      document.querySelector(".Featured_Category");
    if (featuredCategoryElement) {
      featuredCategoryElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    if (signin) {
      setAuthToken(Cookies.get("echohouse_website"));
      setAuthType(Cookies.get("jwtType"));
    } else {
      setAuthToken(null);
      setAuthType(null);
    }
    setReactLoader(false);
  }, [signin, userType]);

  const [shownotificationModal, setNotificationmodal] = useState(false);


  return (
    <>
      <section className="footer desktop-view-footer">
        <div className="container">
          <div className="row footer_row_main  justify-content-center pt-4 pb-2">
            <div className="col-xl-2 col-lg-3 col-md-12 col-sm-12 links">
              <div className="footer_heading_section">
                {/* <a className="navbar-brand">
                  <FontAwesomeIcon
                    icon={["custom", "search-plus"]}
                    className="logo-icon"
                  />
                  <span className="Hiclousia_footer_logo">Ecohouse</span>
                </a> */}
                <Link to="/">
                  <img
                    className="foot_logo"
                    src={
                      process.env.PUBLIC_URL +
                      "/assets/Images/logo/white_logo.png"
                    }
                  />
                </Link>
              </div>
            </div>

            <div className="col-xl-10 col-lg-9 col-md-12 col-sm-12 links">
              <div className="text-holder"></div>
              <div className="row footer_upper_content">
                <div className=" col-xl-3 col-lg-3 col-md-6 col-12">
                  <div className="text-holder">
                    <h6>Quick Links</h6>
                    <Link to="/"
                     onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                    >
                      <p>Home</p>
                    </Link>
                    <Link to="/blogs"
                     onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                    >
                      <p>Blogs</p>
                    </Link>
                    <Link to="/aboutUs"
                    onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                    >
                      <p>About Us</p>
                    </Link>
                    <Link to="/contact"
                    onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                    >
                      <p>Contact Us</p>
                    </Link>
                  </div>
                </div>

                <div className=" col-xl-3 col-lg-3 col-md-6 col-12">
                  <div className="text-holder">
                    <h6>For Job seekers</h6>
                    {authToken === null && (
                      <Link to="/getotp-jobseeker">
                        <p>Sign In / Sign Up</p>
                      </Link>
                    )}
                    <Link to="" onClick={browseJob}>
                      <p>Browse Job</p>
                    </Link>

                    {authToken === null ? (
                      <Link to="/getotp">
                        <p>Browse Companies</p>
                      </Link>
                    ) : userdata?.type === "Job Seeker" ? (
                      <Link to="/dashboard-job">
                        <p>Browse Companies</p>
                      </Link>
                    ) : (
                      <p onClick={() => setModalShow(true)}>Browse Companies</p>
                    )}
                    {authToken !== null && (
                      <Link onClick={() => setNotificationmodal(true)}>
                        <p>Notifications</p>
                      </Link>
                    )}
                    {authToken === null && (
                      <Link to="/getotp-jobseeker">
                        <p>Notifications</p>
                      </Link>
                    )}
                  </div>
                </div>

                <div className=" col-xl-3 col-lg-3 col-md-6 col-12">
                  <div className="text-holder mt-xl-0 mt-lg-0 mt-md-3">
                    <h6>For Recruiter</h6>
                    {authToken === null && (
                      <Link to="/getotp">
                        <p>Sign In / Sign Up</p>
                      </Link>
                    )}

                    <Link to="/getotp">
                      <p>Job Packages</p>
                    </Link>

                    {/* {authToken === null && (
                      <Link to="/getotp">
                        <p>Post Job</p>
                      </Link>
                    )} */}
                    {/* {userdata === "Recruiter" && (
                      <Link to="/dashboard-job">
                        <p>Post Job</p>
                      </Link>
                    )}
                    {authToken !== null && (
                      <p onClick={() => setModalShow(true)}>Post Job</p>
                    )} */}
                    {authToken === null ? (
                      <Link to="/getotp">
                        <p>Post Job</p>
                      </Link>
                    ) : userdata?.type === "Recruiter" ? (
                      <Link to="/dashboardmain">
                        <p>Post Job</p>
                      </Link>
                    ) : (
                      <p onClick={() => setModalShow(true)}>Post Job</p>
                    )}
                  </div>
                </div>

                <div className=" col-xl-3 col-lg-3 col-md-6 col-12">
                  <div className="text-holder mt-xl-0 mt-lg-0 mt-md-3">
                    <h6>Contact</h6>
                  </div>

                  <div className="text-holder">
                    <div className="text ">
                      <FontAwesomeIcon
                        icon="fa-solid fa-location-dot"
                        className="icon me-1"
                      />
                      {/* <span>
                        Commercial Shop No 1 , Ground Floor C Wiing , Arihant
                        City Pride, Shivaji Nagar Ratnagiri 415612
                      </span> */}
                      <span>
                       Building No./Flat No.: 1024, Green House, Ratnagiri Kolhapur Highway, near Radio Station Ratnagiri, Ratnagiri, Maharashtra.
                      </span> <br/>
                      <span>
                       PIN Code: 415639
                      </span>
                    </div>

                    <div className="text ">
                      <FontAwesomeIcon
                        icon="fa-solid fa-phone"
                        className="icon me-1"
                      />{" "}
                      <span>
                        <a href="tel:9175605247" className="no_inner_text">
                          +91 9175605247
                        </a>{" "}
                      </span>
                    </div>
                    <div className="text">
                      <a
                        href="https://mail.google.com/mail/?view=cm&fs=1&to=admin@ecohouseindia.com"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <FontAwesomeIcon
                          icon="fa-solid fa-envelope"
                          className="icon me-1"
                        />
                        admin@ecohouseindia.com
                      </a>
                    </div>
                  </div>

                  <div className="d-flex">
                    {/* <Link>
                      <FontAwesomeIcon
                        icon={faLinkedin}
                        className="linkedin_icon"
                      />
                    </Link> */}

                    <Link
                      className="icon_holder"
                      target="_blank"
                      to="https://www.instagram.com/ecohouse_india?igsh=c2o3cDUzNXl0MWt0"
                    >
                      <FontAwesomeIcon
                        icon={faInstagram}
                        className="linkedin_icon"
                      />
                    </Link>

                    <Link
                      target="_blank"
                      className="icon_holder"
                      to="https://youtube.com/@vasimnaik-c5g?si=hTkTlBSoIT-FgacK"
                    >
                      <FontAwesomeIcon
                        icon={faYoutube}
                        className="linkedin_icon"
                      />
                    </Link>

                    <Link
                      target="_blank"
                      className="icon_holder"
                      to="https://www.facebook.com/share/1CWCWX737U/"
                    >
                      <FontAwesomeIcon
                        icon={faFacebookF}
                        className="linkedin_icon"
                      />
                    </Link>

                    {/* <Link className="icon_holder">
                      <FontAwesomeIcon
                        icon={faLinkedinIn}
                        className="linkedin_icon"
                      />
                    </Link> */}
                  </div>
                </div>
              </div>
            </div>

            <div className="horizantal_line"></div>
          </div>

          <div className="Footer_bottom_info text-center">
            {/* <span>
              © 2025 All Rights Reserved Terms Of Use | Privacy Policy{" "}
              <Link to="https://profcymaglobal.com/" target="_blank">
                {" "}
                Developed by <span className="link_text_holder">Profcyma</span>
              </Link>
            </span> */}

            <span>
              © 2026 Echohouse All Rights Reserved | Developed by{" "}
              <Link
                target="_blank"
                className="link_text"
                to="https://profcymaglobal.com/"
              >
                Profcyma Solutions Pvt Ltd
              </Link>
            </span>
          </div>
        </div>
      </section>

      {/* mobile-view-start */}
      <section section className=" mobile-view-footer">
        <div className="container">
          <div className="row ">
            <div className="col-md-12 ms-0 me-0">
              <div
                className={`circle_rect_sec ${showIcons ? "show-icons" : ""}`}
              >
                <div className="circle" onClick={toggleIcons}>
                  <div className="plus-icon mt-1">{icon}</div>
                </div>

                {showIcons && (
                  <div className="icons mb-5">
                    {/* <Link to="/talentPool"> */}
                    <Link to="/talentPool">
                      <div className="image-footer ">
                        <div className="icon_holder">
                          <FontAwesomeIcon
                            icon={faCrown}
                            className="footer_icon"
                          />
                        </div>

                        {/* <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/Images/icons/footer1.png"
                          }
                          className="footer_icon_img "
                        /> */}
                        <p>Talent Pool</p>
                      </div>
                    </Link>
                    <Link to="/aboutUs">
                      <div className="image-footer ">
                        <div className="icon_holder">
                          <FontAwesomeIcon
                            icon={faInfoCircle}
                            className="footer_icon"
                          />
                        </div>
                        {/* <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/Images/icons/footer2.png"
                          }
                          className="footer_icon_img "
                        /> */}
                        <p>About Us</p>
                      </div>
                    </Link>
                    <Link to="/">
                      <div className="image-footer">
                        <FontAwesomeIcon
                          className="fontawshome "
                          icon={faHouse}
                        />

                        <p></p>
                      </div>
                    </Link>
                    <Link to="/blogs">
                      <div className="image-footer">
                        <div className="icon_holder">
                          <FontAwesomeIcon
                            icon={faFilePen}
                            className="footer_icon"
                          />
                        </div>

                        {/* <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/Images/icons/footer3.png"
                          }
                          className="footer_icon_img "
                        /> */}
                        <p>Blogs</p>
                      </div>
                    </Link>
                    <Link to="/contact">
                      <div className="image-footer ">
                        <div className="icon_holder">
                          <FontAwesomeIcon
                            icon={faPhone}
                            className="footer_icon"
                          />
                        </div>
                        {/* <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/Images/icons/footer4.png"
                          }
                          className="footer_icon_img"
                        /> */}
                        <p>Contact Us</p>
                      </div>
                    </Link>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      <NotificationModal
        show={shownotificationModal}
        onHide={() => setNotificationmodal(false)}
      />

      <Login_As_Modal
        text={
          userdata?.type === "Recruiter"
            ? "Login As Job Seeker"
            : "Login As Recruiter"
        }
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
};

export default Footer;
